import React from 'react';

export const SignatureSkeleton = () => {
  return <div className='border border-grey-300 rounded-10 py-6 px-10 mt-6 skeleton-loader max-w-lg h-52' />;
};
